
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	props: {
		value: {
			type: [String, Number]
		},
		fancy: Boolean,
		label: {
			type: [Object, String]
		},
		useGoTime: Boolean,
		useBookyearStart: Boolean,
		includeRelativeMonthValues: Boolean,
		includeAllMonthsOption: Boolean
	},
	computed: {
		bookyearStartMonth():number {
			return DossierConfigService.getGeneralConfig().BookYearStartMonth + 1;
		},
		relativeMonthItems():ISelectItem<string>[]{
			return [{
					value: "now",
					text: this.$ct(`common.months.month-of-today`)
				},
				{
					value: "previous",
					text: this.$ct("common.months.previous")
				},
				{
					value: "next",
					text: this.$ct("common.months.next")
				}
			];
		},
		items():ISelectItem<number | string>[] {
			if (this.useBookyearStart) {
				const startMonth = this.bookyearStartMonth || 1;
				const months = Array.from({ length: 12 }, (_, i) => ((startMonth + i - 1) % 12) + 1);

				return months.map((monthNumber, index) => {
					return {
						text: (index + 1) + ". " + this.$ct(`common.months.${monthNumber}`).toString(),
						value: index + 1,
					} as ISelectItem<number>;
				});
			}

			let result:ISelectItem<string | number>[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(d => {
				let value = d;
				if (this.useGoTime) {
					value++;
				}
				return {
					value,
					text: this.$ct(`common.months.${d+1}`).toString()
				} as ISelectItem<number>;
			});
			if (this.includeAllMonthsOption){
				result.unshift({
					value: -1,
					text: this.$ct("common.months.all").toString()
				});
			}
			if (this.includeRelativeMonthValues) {
				result.push(...this.relativeMonthItems);
			}
			return result;
		}
	},
	methods: {
		setValue(val:number) {
			this.$emit("input", val);
		}
	}
});
